// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL Reports API (nestjs)
 * API for reports in WL
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { SpellingByStudentWordDateResponseDto } from './SpellingByStudentWordDateResponseDto'
import {
  SpellingByStudentWordDateResponseDtoFromJSON,
  SpellingByStudentWordDateResponseDtoFromJSONTyped,
  SpellingByStudentWordDateResponseDtoToJSON,
} from './SpellingByStudentWordDateResponseDto'

/**
 *
 * @export
 * @interface SchoolsControllerGetSpellingByStudentWordDate200Response
 */
export interface SchoolsControllerGetSpellingByStudentWordDate200Response {
  /**
   *
   * @type {Array<SpellingByStudentWordDateResponseDto>}
   * @memberof SchoolsControllerGetSpellingByStudentWordDate200Response
   */
  data: Array<SpellingByStudentWordDateResponseDto>
  /**
   *
   * @type {number}
   * @memberof SchoolsControllerGetSpellingByStudentWordDate200Response
   */
  total: number
  /**
   *
   * @type {number}
   * @memberof SchoolsControllerGetSpellingByStudentWordDate200Response
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof SchoolsControllerGetSpellingByStudentWordDate200Response
   */
  itemsPerPage: number
  /**
   * Additional metadata
   * @type {object}
   * @memberof SchoolsControllerGetSpellingByStudentWordDate200Response
   */
  meta?: object
}

/**
 * Check if a given object implements the SchoolsControllerGetSpellingByStudentWordDate200Response interface.
 */
export function instanceOfSchoolsControllerGetSpellingByStudentWordDate200Response(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'data' in value
  isInstance = isInstance && 'total' in value
  isInstance = isInstance && 'page' in value
  isInstance = isInstance && 'itemsPerPage' in value

  return isInstance
}

export function SchoolsControllerGetSpellingByStudentWordDate200ResponseFromJSON(
  json: any,
): SchoolsControllerGetSpellingByStudentWordDate200Response {
  return SchoolsControllerGetSpellingByStudentWordDate200ResponseFromJSONTyped(
    json,
    false,
  )
}

export function SchoolsControllerGetSpellingByStudentWordDate200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SchoolsControllerGetSpellingByStudentWordDate200Response {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: (json['data'] as Array<any>).map(
      SpellingByStudentWordDateResponseDtoFromJSON,
    ),
    total: json['total'],
    page: json['page'],
    itemsPerPage: json['itemsPerPage'],
    meta: !exists(json, 'meta') ? undefined : json['meta'],
  }
}

export function SchoolsControllerGetSpellingByStudentWordDate200ResponseToJSON(
  value?: SchoolsControllerGetSpellingByStudentWordDate200Response | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: (value.data as Array<any>).map(
      SpellingByStudentWordDateResponseDtoToJSON,
    ),
    total: value.total,
    page: value.page,
    itemsPerPage: value.itemsPerPage,
    meta: value.meta,
  }
}
